import { Button, DynamicContent, IconRow } from 'components'

import { BsArrowRightSquare, BsExclamationTriangle } from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import { Submission } from 'common.types'
import './VoterRegErrorScreen.scss'
import { useDynamicFormContent } from 'hooks'
const FIND_VOTING_LOCATION_URL = 'https://vote.pa/early/'

export const VoterRegErrorScreen = () => {
  const submissions = JSON.parse(localStorage.getItem('submissions') ?? '{}')
  const timestamps = Object.keys(submissions).map(Number)
  const mostRecentTimestamp = Math.max(...timestamps)
  const mostRecentValue: Submission =
    submissions[mostRecentTimestamp.toString()]
  const { serverResponse } = mostRecentValue?.apiResponse
  const { t } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.errorScreen`,
  })
  const { formContent } = useDynamicFormContent()
  const overrideContent =
    formContent?.formOverrides?.['voter-registration']?.error?.bottom
  if (!serverResponse?.data?.data?.response) {
    return null
  }
  const errors = serverResponse?.data?.data?.response?.errors
  if (!errors) {
    return null
  }
  const buttonWrapperStyle = { marginTop: 30, marginBottom: 40 }
  return (
    <div className="voger-registration-error">
      <IconRow
        icon={BsExclamationTriangle}
        iconColor="red"
        text={t('notAccepted')}
      ></IconRow>
      {errors
        ? errors.map((error: any) => (
            <p className="voter-registration-error__error">
              {Object.values(error).map((message) =>
                message === 'Mailin Not Eligible.' ||
                message === 'MailIn Not Eligible.' ||
                message === 'Mailln Not Eligible.'
                  ? 'PennDOT ID number'
                  : typeof message === 'string'
                  ? message
                  : '',
              )}
            </p>
          ))
        : null}
      <IconRow
        icon={BsArrowRightSquare}
        iconColor="blue"
        text={t('youStillHaveOptions')}
      ></IconRow>

      {overrideContent ? (
        <DynamicContent data={overrideContent} />
      ) : (
        <>
          <p>{t('optionOne')}</p>
          <p dangerouslySetInnerHTML={{ __html: t('optionTwo') }}></p>
          <p dangerouslySetInnerHTML={{ __html: t('bottomInfo') }} />
          <a href="https://vote.pa/info/register">{t('learnMore')}</a>
        </>
      )}
    </div>
  )
}
